module.exports = __webpack_public_path__ + "data/auth-users.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/auth-users/auth-users.json
// module id = sMLS
// module chunks = 1